export default "__VITE_ASSET__UC$lRGdo__"